// Pager — 공용 페이지네이션 컨트롤(« ‹ 1 2 3 › »). 목록 클라이언트 페이징에 재사용.
// props: page(1부터), totalPages, onPage(p). totalPages<=1이면 렌더 안 함.
import { COLORS } from '../utils/uiStyles';

const pgBtn = (disabled) => ({
  padding: '6px 10px', border: '1px solid #e5e7eb', borderRadius: '6px', background: 'white',
  color: disabled ? '#cbd5e1' : '#374151', cursor: disabled ? 'default' : 'pointer', fontSize: '14px',
});

export default function Pager({ page, totalPages, onPage }) {
  if (!totalPages || totalPages <= 1) return null;
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '4px', padding: '16px', flexWrap: 'wrap' }}>
      <button onClick={() => onPage(1)} disabled={page === 1} style={pgBtn(page === 1)}>«</button>
      <button onClick={() => onPage(page - 1)} disabled={page === 1} style={pgBtn(page === 1)}>‹</button>
      {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
        <button key={p} onClick={() => onPage(p)}
          style={{ padding: '6px 12px', border: '1px solid', borderColor: p === page ? COLORS.primaryBorder : '#e5e7eb', borderRadius: '6px', cursor: 'pointer', background: p === page ? COLORS.primarySoft : 'white', color: p === page ? COLORS.selectedText : '#374151', fontWeight: p === page ? '700' : '400', fontSize: '14px' }}>
          {p}
        </button>
      ))}
      <button onClick={() => onPage(page + 1)} disabled={page === totalPages} style={pgBtn(page === totalPages)}>›</button>
      <button onClick={() => onPage(totalPages)} disabled={page === totalPages} style={pgBtn(page === totalPages)}>»</button>
    </div>
  );
}
